const projetos = [
    {
        título: "Nick Contra a Gangue de Bate-Bolas",
        titulo_en: "Nick Against the Bate-Bolas Gang",
        logline: "Dez anos após ser humilhada em uma luta de Kung Fu contra uma gangue de Bate-Bolas, Nick, uma destemida jovem de 19 anos, é novamente desafiada e se reaproxima da arte marcial para buscar vingança e recuperar sua honra.",
        logline_en: "Ten years after being humiliated in a Kung Fu fight against a gang of a Brazilian group of “Bate-Bolas”, Nick, a fearless 19-year-old, is challenged again and returns to the martial art to seek revenge and regain her honor.",
        imagem_capa:"/projetos/nick.png",
        uri: "nick",
        tipo: "Longa-metragem de ficção",
        tipo_en: "Fiction feature film",
        direção: "Bruno Ribeiro",
        roteiro: "Bruno Ribeiro e Tuanny Medeiros",
        produtora: "Reduto Filmes",
        laboratórios: null,
        fomento: "Selecionado no edital de desenvolvimento Riofilme Pró-Carioca Audiovisual 2023"
    },
    {
        título: "Jéssica",
        titulo_en: "Jéssica",
        logline: "Ao ser enviada contra sua vontade para uma temporada na casa da avó, uma sagaz menina de 9 anos tenta impedir mudanças inevitáveis em sua vida e retornar para casa.",
        logline_en: "After being sent against her will to her grandmother's house, a shrewd 9-year-old girl tries to prevent inevitable changes in her life and return home.",
        imagem_capa:"/projetos/jessica.png",
        uri: "jessica",
        tipo: "Longa-metragem de ficção",
        tipo_en: "Fiction feature film",
        direção: "Tuanny Medeiros",
        roteiro: "Tuanny Medeiros",
        produtora: "Reduto Filmes",
        laboratórios: "13° BrLab Features (2023)",
        fomento: null
    },
    {
        título: "Luis do Charme",
        titulo_en: "Luis do Charme",
        logline: "‘Luis do Charme’ promove um encontro entre pai e filha para abordar a paternidade negra, através da figura de um pai presente, e tratar da memória e envelhecimento de um corpo que dedica sua vida à dança.",
        logline_en: "‘Luis do Charme’ promotes an encounter between father and daughter to address Black paternity through the figure of a present father and to deal with the memory and aging of a body that dedicates its life to dance.”",
        imagem_capa:"/projetos/luis.png",
        uri: "luis",
        tipo: "Curta-metragem documentário",
        tipo_en: "Documentary short film",
        direção: "Tuanny Medeiros",
        roteiro: "Tuanny Medeiros",
        produtora: "Reduto Filmes",
        laboratórios: null,
        fomento: "Selecionado no edital Sesc Pulsar 2023, Selecionado no edital de produção para novos realizadores - Riofilme Pró-Carioca Audiovisual 2023"
    }
]

export default projetos